import React from "react";

const Button = ({message, bgColor, bgText}) => {
    return <button className="header-btn" style={{backgroundColor:bgColor,color:bgText}}><b>{message}</b></button>
}

export default Button